import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore/lite";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// 이전 정보.
// const firebaseConfig = {
//   apiKey: "AIzaSyA2AUWEROA5MM_mMhLtZUyZ0_K2IEMKCYA",
//   authDomain: "cancer-screening-e0c6e.firebaseapp.com",
//   projectId: "cancer-screening-e0c6e",
//   storageBucket: "cancer-screening-e0c6e.appspot.com",
//   messagingSenderId: "738043130875",
//   appId: "1:738043130875:web:b65a0a1baa6c19ac90515e",
//   measurementId: "G-26Z596BQYR"
// };
const firebaseConfig = {
  apiKey: "AIzaSyDc3J2P-805bjhSjKYkZHe0l98Wd8oTAK8",
  authDomain: "cancer-screening-47a69.firebaseapp.com",
  projectId: "cancer-screening-47a69",
  storageBucket: "cancer-screening-47a69.appspot.com",
  messagingSenderId: "239584309694",
  appId: "1:239584309694:web:a01775d1ecaf0a043c49ef",
  measurementId: "G-Z48EPGBNC5",
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
